document.addEventListener("DOMContentLoaded", function () {
  let lastFocusedElement = null;

  // =========================
  // Form focus issue
  // =========================
  document.addEventListener("click", function (e) {
    if (e.target.closest(".trigger-lot_popup")) {
      lastFocusedElement = e.target.closest(".trigger-lot_popup");
      const popup = document.querySelector(".lot_popup");
      if (popup) {
        popup.setAttribute("tabindex", "-1");
        popup.focus();
      }
    }

    if (e.target.closest(".btn-close")) {
      if (lastFocusedElement) lastFocusedElement.focus();
    }
  });

  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") {
      document
        .querySelectorAll(".lot_popup")
        .forEach((el) => el.classList.add("hide"));
      if (lastFocusedElement) lastFocusedElement.focus();
    }
  });


  // =========================
  // Third party warning
  // =========================
  const warningText =
    "Redirecting to a third-party website (opens in a new tab).";

  function isThirdParty(url) {
    try {
      const linkHost = new URL(url, window.location.href).hostname;
      return linkHost && linkHost !== window.location.hostname;
    } catch {
      return false;
    }
  }

  function handleExternalLinks() {
    document.querySelectorAll("a").forEach(function (link) {
      const href = link.getAttribute("href");
      if (!href || !isThirdParty(href)) return;

      link.setAttribute("target", "_blank");

      const img = link.querySelector("img");

      if (img) {
        link.removeAttribute("aria-label");

        let alt = img.getAttribute("alt") || "";
        if (!alt.includes(warningText)) {
          img.setAttribute("alt", alt ? alt + ", " + warningText : warningText);
        }
        return;
      }

      if (link.classList.contains("et_pb_button")) {
        link.removeAttribute("aria-label");

        if (!link.querySelector(".visually-hidden")) {
          const span = document.createElement("span");
          span.className = "visually-hidden";
          span.textContent = warningText;
          link.appendChild(span);
        }
        return;
      }

      const text = link.textContent.trim();
      if (!text) return;

      const aria = link.getAttribute("aria-label");
      if (!aria || !aria.includes(warningText)) {
        link.setAttribute("aria-label", text + ", " + warningText);
      }
    });
  }

  setTimeout(handleExternalLinks, 500);

  // =========================
  // Email & phone labels
  // =========================
  document
    .querySelectorAll('a[href^="mailto:"], a[href^="tel:"]')
    .forEach(function (el) {
      const href = el.getAttribute("href");

      if (
        el.hasAttribute("aria-label") ||
        el.getAttribute("role") === "button" ||
        el.classList.contains("button") ||
        el.classList.contains("btn")
      ) {
        return;
      }

      if (href.startsWith("mailto:")) {
        const email = href.replace("mailto:", "").trim();
        el.setAttribute("aria-label", "Email Address: " + email);
      }

      if (href.startsWith("tel:")) {
        const text = el.textContent.trim();
        el.setAttribute("aria-label", "Phone number: " + text);
      }
    });

  // =========================
  // aria-hidden on <br>
  // =========================
  document.querySelectorAll("br").forEach((br) => {
    br.setAttribute("aria-hidden", "true");
  });

  // =========================
  // Cart drawer tabs
  // =========================
  document.querySelectorAll("button.drawer__tab").forEach((btn) => {
    const observer = new MutationObserver(() => {
      const expanded = btn.getAttribute("aria-expanded") === "true";
      btn.setAttribute("aria-selected", expanded ? "true" : "false");
    });

    observer.observe(btn, {
      attributes: true,
      attributeFilter: ["aria-expanded"],
    });
  });

  // =========================
  // Drawer close cleanup
  // =========================
  document.addEventListener("click", function (e) {
    if (
      e.target.closest(
        "a.cart-drawer-button, a.search-drawer-button, .facet-wrapper button, .icon.icon-question button, .drawer__close",
      )
    ) {
      setTimeout(() => {
        document
          .querySelectorAll(
            ".drawer__header button, .drawer__sticky button, .drawer__tabs li button",
          )
          .forEach((btn) => btn.removeAttribute("aria-expanded"));
      }, 300);
    }
  });

  // =========================
  // Complex image toggle
  // =========================
  document.querySelectorAll(".image-description-toggle").forEach((btn) => {
    btn.addEventListener("click", function () {
      const contentId = btn.getAttribute("aria-controls");
      const content = document.getElementById(contentId);
      if (!content) return;

      const expanded = btn.getAttribute("aria-expanded") === "true";
      btn.setAttribute("aria-expanded", !expanded);
      content.hidden = expanded;
    });
  });

  // =========================
  // Menu + FAQ aria-expanded
  // =========================
  function updateAria() {
    document.querySelectorAll(".magnet-element.menu__item").forEach((el) => {
      const parent = el.closest("details");
      el.setAttribute(
        "aria-expanded",
        parent && parent.open ? "true" : "false",
      );
    });

    document.querySelectorAll("summary.subdrop1").forEach((el) => {
      const parent = el.closest("details");
      el.setAttribute(
        "aria-expanded",
        parent && parent.open ? "true" : "false",
      );
    });

    document.querySelectorAll(".accordion details summary").forEach((el) => {
      const parent = el.closest("details");
      el.setAttribute(
        "aria-expanded",
        parent && parent.open ? "true" : "false",
      );
    });
  }

  updateAria();

  document.querySelectorAll("details").forEach((detail) => {
    detail.addEventListener("toggle", updateAria);
  });

  // =========================
  // Promo aria-label
  // =========================
  document.querySelectorAll(".promo-box").forEach((box) => {
    const title = box.querySelector(".promo-title")?.textContent.trim() || "";
    const btnText = box.querySelector("a .btn-text")?.textContent.trim() || "";

    const link = box.querySelector("a");
    if (link) link.setAttribute("aria-label", btnText + " " + title);
  });
  // =========================
  // Video tag aria-label fix
  // =========================
// document.querySelectorAll("video").forEach(function (el) {
//   setTimeout(() => {
//     el.removeAttribute("aria-label");
//   }, 6000);
// });

  // =========================
  // Product price fix
  // =========================
  document.querySelectorAll(".price--on-sale").forEach((wrapper) => {
    wrapper.querySelectorAll(".sr-only").forEach((el) => {
      if (el.textContent.toLowerCase().includes("regular price")) {
        el.remove();
      }
    });

    const sale = wrapper.querySelector(".price__sale");
    if (sale) {
      const span = document.createElement("span");
      span.className = "sr-only";
      span.textContent = "Regular price ";
      sale.prepend(span);
    }
  });
});

document.addEventListener("DOMContentLoaded", function () {

  function removeAriaLabel() {
    document.querySelectorAll("video[aria-label]").forEach(function (el) {
      el.removeAttribute("aria-label");
    });
  }
  removeAriaLabel();
  setInterval(removeAriaLabel, 500);
  const observer = new MutationObserver(removeAriaLabel);
  observer.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ["aria-label"]
  });

  // =========================
  // zonos empty button
  // =========================
setTimeout(function () {
  function removeZonosButton() {
    document
      .querySelectorAll("#zonos--checkout-hidden-international-button")
      .forEach(function (el) {
        const text = (el.textContent || "").trim();
        const aria = el.getAttribute("aria-label");

        if (!text && !aria) {
          el.remove();
        }
      });
  }

  // Run once immediately
  removeZonosButton();

  const observer = new MutationObserver(function (mutations) {
    mutations.forEach(function () {
      removeZonosButton();
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
}, 1500);

  

});